module.exports = __webpack_public_path__ + "img/learn-more-illu-search.392eb62c.svg";